import { useEffect, useRef } from "react";
import ScrollReveal from "scrollreveal";

interface IcardWithMe {
    part_text_one: string
    part_text_two: string,
    part_text_three: string
}

export const CardWithMe = ({part_text_one, part_text_two, part_text_three}:IcardWithMe) => {

//Defindo a variavel REF
const leftCard = useRef<HTMLDivElement | null>(null);
const rightCard = useRef<HTMLDivElement | null>(null)

  //Usando o useeffect para renderizar
  useEffect(() => {

    //Definindo abreviação scrollreview
    const sr = ScrollReveal();

    //Condição para a animação
    if (leftCard.current) {
      sr.reveal(leftCard.current, {
        duration: 1500,
        origin: "bottom",
        distance: "100px",
        easing: 'ease-in-out',
        reset: false
      });
    }

    if(rightCard.current) {
        sr.reveal(rightCard.current, {
            duration: 1500,
            origin: 'right',
            distance: '100px',
            easing: 'ease-in-out',
            reset: false
        })
    }

    return () => sr.destroy();
  }, []);

    
    return(

        
        <article className="flex flex-col md:flex-row mt-7 gap-x-10 ">
            <div 
            ref={leftCard}
            className="flex flex-col  md:w-[60vw] md:h-[50vh] gap-y-6 text-start p-5 text-gray-300 fontText">
                <span>
                    {part_text_one}
                </span>

                <span>
                    {part_text_two}
                </span>

                <span>
                    {part_text_three}
                </span>
            </div>

            <div 
            ref={rightCard}
            className="bg-gray-950 md:w-[20vw] h-[50vh] p-3 rounded-md wallpaperWith">
                <div  className="border border-red-600 md:w-[20vw] h-[50vh] rounded-md">

                </div>
            </div>
        </article>

    )
}